const R_EMPTY = /^\s*$/;
export default function isEmpty(value) {
    return value == null || R_EMPTY.test(value);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/isEmpty.ts